/** Скачанный файл: тело и имя из Content-Disposition (имени нет — null). */
export type DownloadedFile = { blob: Blob; fileName: string | null };

/** Имя файла из Content-Disposition: filename* (RFC 5987, UTF-8) важнее filename. */
export function fileNameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      return null;
    }
  }
  return /filename="?([^";]+)"?/i.exec(header)?.[1] ?? null;
}
